import React from 'react';
import { Chart } from 'react-google-charts';

const Analytics = (props) => {
  return (<div className={'w-100'}>
    <Chart
      width={`100%`}
      height={'350px'}
      chartType="AreaChart"
      loader={<div>Loading Chart</div>}
      data={[
        ['Year', 'Sales'],
        ['2013', 1000],
        ['2014', 1170],
        ['2015', 660],
        ['2016', 1030],
      ]}
      options={{
        legend: "none",
        hAxis: { },
        vAxis: { minValue: 0 },
        chartArea: { width: '75%', height: '70%' },
        colors: ['#f77719']
      }}
      rootProps={{ 'data-testid': '1' }}
    />
  </div>)
};

export default Analytics;
